import { getBuildStageIndex, resolveBuildStages } from '@/components/build/build-stage-config';
import { cn } from '@/lib/utils';
import { CheckIcon, CircleIcon, LoaderIcon } from 'lucide-react';

interface BuildStageStepperProps {
	currentStage?: string | null;
	sawDropperStage?: boolean;
	sawPayloadEncryptStage?: boolean;
	skipEncrypt?: boolean;
	className?: string;
}

export default function BuildStageStepper({
	currentStage,
	sawDropperStage = false,
	sawPayloadEncryptStage = false,
	skipEncrypt = false,
	className,
}: BuildStageStepperProps) {
	const stages = resolveBuildStages(sawDropperStage, currentStage, skipEncrypt, sawPayloadEncryptStage);
	const currentIndex = getBuildStageIndex(stages, currentStage);

	return (
		<div className={cn('flex flex-wrap gap-2', className)}>
			{stages.map((stage, index) => {
				const isDone = currentIndex > index;
				const isCurrent = currentIndex === index;
				const isPending = currentIndex < index;

				return (
					<div
						key={stage.id}
						className={cn(
							'flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs',
							isDone && 'border-chart-2/40 bg-chart-2/10 text-chart-2',
							isCurrent && 'border-chart-5/40 bg-chart-5/10 text-chart-5',
							isPending && 'border-border bg-muted/40 text-muted-foreground',
						)}
					>
						{isDone ? (
							<CheckIcon className='size-3.5 shrink-0' />
						) : isCurrent ? (
							<LoaderIcon className='size-3.5 shrink-0 animate-spin' />
						) : (
							<CircleIcon className='size-3.5 shrink-0 opacity-50' />
						)}
						<span>{stage.label}</span>
					</div>
				);
			})}
		</div>
	);
}
